// Heading View
var Marionette = require('backbone.marionette');
var $ = require('jquery');
var template = require('./template.hbs');

module.exports = Marionette.ItemView.extend({
	template: template,

	initialize: function(){
		this.listenTo(UCS.App.MapState, 'change:selection', this.update);
		this.update();
	},
	onAttach: function(){
		this.update();
	},
	update: function(){
		var d = UCS.App.MapState.get('selection');

		if(UCS.App.MapState.get('zoomed') === false ){
			$('.details-layout .heading h2').html('California Overview');
			$('.details-layout .heading p').slideDown();
			return;
		}

		if(d.boundary_kind === 'County'){
			$('.details-layout .heading h2').html( d.district_name + " " + d.boundary_kind );
			$('.details-layout .heading p').slideUp();
		} else {
			$('.details-layout .heading h2').html( d.boundary_kind + " " + d.district_number );
			$('.details-layout .heading p').slideUp();
		}


	}
});
